var InfiniteScrollView = require('../mixins/infinite-scroll-view')

module.exports = Em.View.extend(InfiniteScrollView, {
    scrollSelector: '.section-body',

    itemHeight: 56
})
